module.exports = __webpack_public_path__ + "images/ic_assignment_white_24px.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/ic_assignment_white_24px.svg
 ** module id = 61
 ** module chunks = 1
 **/